(() => {
  const readConfig = (id) => {
    try {
      return JSON.parse(document.getElementById(id)?.textContent || '{}');
    } catch (error) {
      return {};
    }
  };

  const countStores = (config, variantId) => {
    if (!variantId) return 0;

    const inventory = config.variants?.[String(variantId)]?.inventory || {};

    return (config.stores || []).filter((store) => (
      Number(inventory?.[String(store.id)] || 0) > 0
    )).length;
  };

  const installPdpStoreAvailability = () => {
    const configNode = document.querySelector('[data-faf-store-config]');
    const nativeRegion = document.querySelector('[data-native-atc-region]');

    if (!configNode || !nativeRegion) return;

    const config = readConfig(configNode.id);
    let variantId = String(config.initialVariantId || '');

    const legacyTrigger = Array.from(nativeRegion.querySelectorAll('button')).find((button) => (
      String(button.getAttribute('x-on:click') || '').includes('show-store-stock') ||
      String(button.getAttribute('@click') || '').includes('show-store-stock')
    ));

    // The native trigger only exists for the GB market. Do not create a store
    // availability route on markets where the PDP intentionally omits it.
    if (!legacyTrigger) return;

    legacyTrigger.hidden = true;
    legacyTrigger.tabIndex = -1;
    legacyTrigger.setAttribute('aria-hidden', 'true');

    let trigger = nativeRegion.querySelector('[data-faf-store-trigger]');

    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.hidden = true;
      trigger.dataset.fafStoreTrigger = '';
      trigger.className = 'block pb-4 body-small underline underline-offset-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sg-navy focus-visible:ring-offset-4';
      trigger.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent('show-store-stock', {
          detail: { trigger, variantId }
        }));
      });
      nativeRegion.appendChild(trigger);
    }

    const updateTrigger = () => {
      const count = countStores(config, variantId);
      const hasStoreStock = count > 0;

      window.requestAnimationFrame(() => {
        trigger.hidden = !hasStoreStock;
        trigger.disabled = !hasStoreStock;
        trigger.setAttribute('aria-hidden', hasStoreStock ? 'false' : 'true');
        trigger.textContent = hasStoreStock
          ? `Available in ${count} ${count === 1 ? 'store' : 'stores'} — Find in store`
          : '';
      });
    };

    window.addEventListener('variant-change', (event) => {
      const detail = event.detail || {};

      if (
        config.productId &&
        detail.productId &&
        String(detail.productId) !== String(config.productId)
      ) {
        return;
      }

      variantId = detail.variantId ? String(detail.variantId) : '';
      updateTrigger();
    });

    updateTrigger();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installPdpStoreAvailability, { once: true });
  } else {
    installPdpStoreAvailability();
  }
})();
